<div class="activity-header display-row-flex">
  <!--Needed for language-->
  <!-- <div style="  display: flex;">
  <span class="header__language-label default-sub-header">{{'language' | translate}}</span>
  <dynamic-form [config]="languageConfig"></dynamic-form>
</div> -->
<div class="header-content">
  <div class="property-info">
    <div class="property-name">{{activityService.restaurantWidgetName}}</div>
    <div class="property-addr">
      <div class="class-info__detail__location">
        <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
        &nbsp;{{propertyLocation}}
      </div>
    </div>
  </div>
</div>
@if (isCartEnabled) {
  <div class="headercontainer__cart-section">
    <mat-icon class="shopping_cart" aria-hidden="false" aria-label="Shopping Cart" (click)="showCartItems()"> <i
      class="material-icons icon">shopping_cart
      @if (activityService.cartCount > 0) {
        <span class="count-batch">{{activityService.cartCount}}</span>
      }
    </i></mat-icon>
  </div>
}
<div class="language-content display-row-flex">
  <div class="lang-select">{{'language' | translate}}</div>
  <div class="lang-select">
    <dynamic-form class="header" [config]="languageConfig"></dynamic-form>
  </div>
</div>
</div>